import styled from 'styled-components';

import { TextInputMasked } from 'components/modules/Insurance/Insurance.styles';

import { MILEAGE_MASK, NAME } from './MileageInput.constants';

export const MileageInput = styled(TextInputMasked).attrs({
  label: 'Пробег',
  mask: MILEAGE_MASK,
  name: NAME,
})`
  grid-column: 1 / 3;
`;
